var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"btn"},[_c('div',{staticClass:"go",on:{"click":_vm.turn}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }